import { msg } from '@lingui/core/macro';

export const SHARED_TAG_PILL_ASSIGNED = msg`Pathway Assigned`;
export const SHARED_TAG_PILL_PASSED = msg`Passed`;
export const SHARED_TAG_PILL_FAILED = msg`Failed`;
export const SHARED_TAG_PILL_COMPLETED = msg`Completed`;
export const SHARED_TAG_PILL_UNASSIGNED = msg`Pathway Unassigned`;
export const SHARED_TAG_PILL_UNSUBSCRIBED = msg`Pathway Unsubscribed`;
export const SHARED_TAG_PILL_LEARNING = msg`Learning`;
export const SHARED_TAG_PILL_ASSESSMENT = msg`Assessment`;
export const SHARED_TAG_PILL_SURVEY = msg`Survey`;
export const SHARED_TAG_PILL_TASK_EVALUATION = msg`Task-Evaluation`;
export const SHARED_TAG_PILL_NEW = msg`New`;
export const SHARED_TAG_PILL_SYSTEM = msg`System`;
export const SHARED_TAG_PILL_REMINDER = msg`Reminder`;
export const SHARED_TAG_PILL_FINAL_REMINDER = msg`Final Reminder`;
export const SHARED_TAG_PILL_ABORTED = msg`Aborted`;
export const SHARED_TAG_PILL_OVERDUE = msg`Overdue`;
export const SHARED_TAG_PILL_INFO = msg`Info`;
export const SHARED_TAG_PILL_SECURITY = msg`Security`;
export const SHARED_TAG_PILL_MAINTENANCE = msg`Maintenance`;
export const SHARED_TAG_PILL_TASK_REDO = msg`Re-do`;
export const SHARED_TAG_PILL_TASK_ASSESSOR_CHANGED = msg`Assessor Changed`;
export const SHARED_TAG_PILL_TASK_RECALLED_CREW_SIGN_OFF = msg`Auto-recalled - Crew sign off`;
export const SHARED_TAG_PILL_TASK_EXEMPTED = msg`Exempted`;
export const SHARED_TAG_PILL_TASK_RECALLED_ASSESSOR_SIGN_OFF = msg`Auto-recalled - Assessor sign off`;
export const SHARED_TAG_PILL_TASK_RECALLED_ELEMENT_UPDATED = msg`Auto-recalled - Task element updated`;
export const SHARED_TAG_PILL_TASK_RECALLED_ELEMENT_DELETED = msg`Auto-recalled - Task element deleted`;
export const SHARED_TAG_PILL_TASK_RECALLED_ASSESSOR_UNAVAILABLE = msg`Auto-recalled - Shore assessor unavailable`;
export const SHARED_TAG_PILL_TASK_EXEMPTION_REJECTED = msg`Exemption Rejected`;
export const SHARED_TAG_PILL_TASK_RECEIVED_FOR_EVALUATION = msg`Received for evaluation`;
export const SHARED_TAG_PILL_TASK_RECEIVED_FOR_EXEMPTION = msg`Received for exemption`;
export const SHARED_TAG_PILL_TASK_RECALLED_BY_ASSESSEE = msg`Recalled by Assessee`;
export const SHARED_TAG_PILL_TASK_CLOSED = msg`Closed`;
